// src/pages/SupportDesk.jsx
import React from "react";
import "./SupportDesk.css";

const SupportDesk = () => {
  return (
    <section className="support-section" data-aos="fade-up">
      <div className="support-content">
        <div className="support-header">
          <span className="support-pill">We’re here to Assist</span>
          <h2 className="support-title reveal-text">
            SUPPORT &amp; ENQUIRY DESK
          </h2>
          <div className="support-underline" />
          <p className="support-subtitle">
            Reach out our team for admission queries and know more about School, We are happy to guide you.
          </p>
        </div>

        <div className="support-grid">
          <div className="support-card">
            <div className="support-card-icon">📞</div>
            {/*<h3>Contact Details</h3>*/}
            <p>
              <strong>Phone:</strong>{" "}
              <a href="tel:+91XXXXXXXXXX">+91-8977753424</a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:info@vvcms.edu.in">vvcmschool@gmail.com</a>
            </p>
            <p>
              <strong>Office Timings:</strong> 9:00 AM – 4:00 PM (Mon–Sat)
            </p>
          </div>

          <div className="support-card">
            <div className="support-card-icon">📍</div>
            <h3>Visit Us</h3>
            <p>Google Map Location:</p>
            <p>
              <a
                href="https://www.google.com/maps/search/Vivek+Vardhini+Creative+Minds+School"
                target="_blank"
                rel="noreferrer"
              >
                Open on Google Maps
              </a>
            </p>
          </div>

          <div className="support-card">
            <div className="support-card-icon">🌐</div>
            <h3>Social Media</h3>
            <ul className="support-social">
              <li>
                <a
                  href="https://www.facebook.com/vvcreativemindsschool"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/vvcreativemindsschool/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@VVCreativeMindsSchool"
                  target="_blank"
                  rel="noreferrer"
                >
                  YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportDesk;
